@if (hasLanguages()) {
  <ix-button
    #badge
    [id]="badgeId"
    [disabled]="isSingleLanguage()"
    [attr.aria-label]="accessibleName()"
    [attr.aria-haspopup]="!isSingleLanguage() ? 'listbox' : null"
    [attr.aria-expanded]="!isSingleLanguage() ? isOpen() : null"
    [attr.aria-controls]="!isSingleLanguage() ? listboxId : null"
    class="language-picker-badge"
    onkeypress=""
    variant="secondary"
    (click)="toggleMenu()">
    <span class="language-picker-badge__content">
      <span class="language-picker-badge__icon-box" aria-hidden="true">
        @if (flagIconPath(); as flagPath) {
          <img class="language-picker-badge__flag" [src]="flagPath" alt="" width="18" height="13" />
        } @else {
          <span class="language-picker-badge__code">{{ effectiveLanguage()?.toUpperCase() }}</span>
        }
      </span>
    </span>
    @if (!isSingleLanguage()) {
      <ix-icon name="chevron-down" size="16" slot="end" aria-hidden="true"></ix-icon>
    }
  </ix-button>

  @if (isOpen()) {
    <ix-dropdown class="language-picker-menu" [anchor]="badgeId" [show]="isOpen()" [closeBehavior]="false">
      <div class="language-picker-menu__body" (keydown)="onMenuKeydown($event)">
        <div class="language-picker-menu__row">
          <ix-input
            #searchInput
            [id]="searchInputId"
            [value]="searchQuery()"
            aria-label="Filter languages"
            [placeholder]="'Filter languages'"
            [attr.aria-controls]="listboxId"
            class="language-picker-menu__search"
            type="text"
            (input)="onSearchInput(searchInput.value)"
            (change)="onSearchInput(searchInput.value)">
            <ix-icon name="search" size="16" slot="start"></ix-icon>
          </ix-input>

          <ix-checkbox
            [id]="applyToAllId"
            [checked]="applyToAll()"
            class="language-picker-menu__apply-all"
            label="Apply to all"
            (checkedChange)="onApplyToAllChange($event.detail)">
          </ix-checkbox>
        </div>

        <ul class="language-picker-menu__list"
            role="listbox"
            [id]="listboxId"
            aria-label="Languages">
          @for (entry of filteredEntries(); track entry.languageCode; let i = $index) {
            <li #optionRef
                role="option"
                class="language-picker-menu__option"
                [tabindex]="i === tabbableIndex() ? 0 : -1"
                [attr.aria-selected]="entry.languageCode === effectiveLanguage()"
                (click)="pickLanguage(entry.languageCode)"
                (keydown.enter)="pickLanguage(entry.languageCode)"
                (keydown.space)="$event.preventDefault(); pickLanguage(entry.languageCode)">
              <span class="language-picker-menu__option-flag">
                @if (flagPathFor(entry.languageCode); as optionFlagPath) {
                  <img [src]="optionFlagPath" alt="" width="16" height="16" />
                } @else {
                  <span class="language-picker-menu__option-code">{{ entry.languageCode.toUpperCase() }}</span>
                }
              </span>
              <span class="language-picker-menu__option-name">{{ displayNameFor(entry.languageCode) }}</span>
              @if (entry.languageCode === effectiveLanguage()) {
                <ix-icon name="check" size="16" class="language-picker-menu__option-check"></ix-icon>
              }
            </li>
          }
        </ul>
      </div>
    </ix-dropdown>
  }
}

<div class="visually-hidden" aria-live="polite">{{ announcement() }}</div>
